import ToggleTabs from '@cp/src/components/toggleTabs/ToggleTabs';
import { Typography } from '@navi/web-ui/lib/primitives';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';

interface DashBoardHeaderProps {
  cycle: string;
  setCycle: (cycle: string) => void;
}
const DashBoardHeader = (props: DashBoardHeaderProps) => {
  const { cycle, setCycle } = props;
  const name = useSelector((store: RootState) => store?.common?.userData?.name);
  const cycleData =
    useSelector((state: RootState) => state.telePerformanceDashboard.cycleOptions) || [];

  const handleViewChange = (value: string | boolean) => {
    setCycle(value as string);
  };
  return (
    <div className="flex flex-row justify-between mb-3">
      <Typography variant="h2" color="var(--grayscale-1)">
        Hi, {name || ''}
      </Typography>
      {cycleData && cycleData.length > 0 && (
        <ToggleTabs
          selected={cycle}
          onTabClick={value => handleViewChange(value)}
          tabOptions={cycleData}
          size="h5"
          tabClass="!mt-0 !mb-0"
        />
      )}
    </div>
  );
};
export default DashBoardHeader;
